import { ReactNode } from 'react';

import { Actions, Root, Subtitle, Title, TitleBlock } from './styles';

interface PageHeaderProps {
  title: string;
  /** One line, sentence case, no trailing period. */
  subtitle?: string;
  /** At most two buttons: [secondary] [the single primary]. */
  actions?: ReactNode;
  /** Optional controls that belong to the title row (e.g. view toggle). */
  aside?: ReactNode;
}

/**
 * Page header: text on the canvas, no background, no border (guide 7.3).
 * Replaces the uppercase `TitleTypography` pattern.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  aside,
}: PageHeaderProps): JSX.Element {
  return (
    <Root>
      <TitleBlock>
        <Title component="h1">{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TitleBlock>
      {aside}
      {actions && <Actions>{actions}</Actions>}
    </Root>
  );
}
